import { Dispatch } from 'redux';
import { SELECT_PROMO_CODE, AdminDispatchTypes } from './types';

export const selectPromoCode = (id: number) => async (dispatch: Dispatch<AdminDispatchTypes>) => {
  dispatch({type: SELECT_PROMO_CODE, payload: id});
}
